module.exports = __webpack_public_path__ + "static/media/wf.ebb0ffa4.svg";